import { eventCategoryText } from 'constants/eventCategories';
import { taskTypeLabel } from 'constants/taskTypes';
import useText from 'hooks/useText';
import { useMemo } from 'react';

// The texts of the home page (locales: home.*), with the labels of the
// appointment categories and the task types.
const useHomeText = () => {
  const base = useText('home');
  return useMemo(
    () => ({
      ...base,
      categoryLabel: (category) => eventCategoryText(base.language, category, 'label'),
      categoryTitle: (category) => eventCategoryText(base.language, category, 'title'),
      typeLabel: (type) => taskTypeLabel(base.language, type),
    }),
    [base],
  );
};

export default useHomeText;
